<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="700px"
    :append-to-body="true"
    :show-close="false"
  >
    <img
      class="close-img"
      alt="close-icon.png"
      @click="dialogVisible = false"
      src="@/assets/img/images/icon/close-icon.png"
    />
    <p class="p1">
      {{ $t("buy_box.withdraw") }}
      <span :class="[{ sel: typeValue1 === 1 }]" @click="typeChange1(1)">
        {{ $t("buy_box.chain_withdraw") }}</span
      >
      <!-- <span :class="[{ sel: typeValue1 === 2 }]" @click="typeChange1(2)" >内部提现</span> -->
    </p>
    <p class="p2">
      {{ $t("withdrawCoins.coin_type") }}
    </p>
    <el-select
      v-model="currRow.assetType"
      :placeholder="$t('withdrawCoins.coin_type')"
      class="coin-select"
      @change="selectCoinType"
    >
      <el-option
        v-for="coin in coinTypesList"
        :key="coin"
        :label="coin | replaceUSDT"
        :value="coin"
      />
    </el-select>
    <p class="p2" v-if="typeValue1 === 1">
      {{ $t("user_assets.blockchain_type") }}：
    </p>
    <div class="type-box">
      <p
        v-for="item in networksList"
        :class="[{ sel: networkValue === item }]"
        @click="typeChange(item)"
      >
        {{ item }}
      </p>
    </div>

    <el-form
      v-loading="loading"
      class="mt20"
      :model="withdrawData"
      :rules="rules"
      ref="ruleFormAuthentication"
    >
      <el-form-item :label="$t('user_assets.choice_address')" prop="address">
        <p class="add-choice-address">
          <span @click="addChoiceAddress">{{
            $t("tipsVal.setChoiceAddress")
          }}</span>
        </p>
        <el-select
          style="width: 100%"
          :placeholder="$t('user_assets.choice_address_placeholder')"
          v-model="withdrawData.address"
        >
          <el-option
            v-for="item in withdrawList"
            :key="item.address"
            :label="item.alias + ':' + item.address"
            :value="item.address"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('user_assets.withdraw_amount')" prop="amount">
        <p class="add-choice-address" @click="setWithdrawAmount">
          <span>{{
            $t("user_assets.available") + withdrawObj.balanceAvailable
          }}</span>
        </p>
        <el-input
          type="number"
          :maxlength="18"
          oninput="if(this.value.length>18) this.value=this.value.slice(0,18)"
          :placeholder="
            $t('user_assets.withdraw_amount_placeholder1') +
            withdrawObj.minAmount +
            '，' +
            $t('user_assets.withdraw_amount_placeholder2') +
            withdrawObj.maxAmount
          "
          v-model="withdrawData.amount"
        >
        </el-input>
      </el-form-item>

      <el-form-item :label="$t('user_assets.trans_password')" prop="password">
        <el-input
          type="password"
          :maxlength="30"
          :placeholder="$t('user_assets.trans_password_placeholder')"
          v-model="withdrawData.password"
        >
        </el-input>
      </el-form-item>

      <el-form-item
        v-if="user.phoneSecurity === 1"
        class="form-item"
        :label="$t('user_assets.phone_code')"
        prop="phoneCode"
      >
        <el-input
          :maxlength="6"
          :placeholder="$t('user_assets.phone_code_placeholder')"
          v-model="withdrawData.phoneCode"
        >
          <template slot="append"
            ><span v-if="!phoneCodeStatus.hasSend" @click="hasSendPhoneCode">
              {{ $t("user_assets.get_code") }}
            </span>
            <span v-else>{{ phoneCodeStatus.times }}</span></template
          >
        </el-input>
      </el-form-item>

      <el-form-item
        v-if="user.emailSecurity === 1"
        :label="$t('user_assets.email_code')"
        prop="emailCode"
      >
        <el-input
          :maxlength="6"
          :placeholder="$t('user_assets.email_code_placeholder')"
          v-model="withdrawData.emailCode"
        >
          <template slot="append"
            ><span
              v-if="!emailCodeStatus.hasSend"
              class="btn-min right"
              @click="hasSendEmailCode"
            >
              {{ $t("user_assets.get_code") }}
            </span>
            <span v-else class="btn-min right has-send">{{
              emailCodeStatus.times
            }}</span></template
          >
        </el-input>
      </el-form-item>

      <el-form-item
        v-if="user.googleSecurity === 1"
        :label="$t('user_assets.google_code')"
        prop="googleCode"
      >
        <el-input
          :maxlength="6"
          :placeholder="$t('user_assets.google_code_placeholder')"
          v-model="withdrawData.googleCode"
        >
        </el-input>
      </el-form-item>

      <p class="p3">
        {{ $t("user_assets.fee") }}{{ withdrawObj.fee
        }}
        <span v-if="beforeRow">{{ beforeRow.assetType | replaceUSDT }}</span>
      </p>
      <el-button class="btn" @click="doWithdraw">{{
        $t("buy_box.confirm")
      }}</el-button>
    </el-form>

    <AddAsset ref="addAssetRef" @submitBack="init(currRow)" />
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import AddAsset from "@/components/Dialog/AddAsset.vue";
export default {
  components: {
    AddAsset,
  },
  data() {
    return {
      loading: false,
      currRow: {
        assetType: "",
      },
      networkValue: "",
      coinTypesList: [],
      typeValue1: 1,
      typeValue2: 1,
      chainList: [
        {
          value: "BSC",
          name: "BNB Smart Chain(BEP20)",
        },
        {
          value: "ETH",
          name: "Ethereum(ERC20)",
        },
        // {
        //   value: "TRC20",
        //   name: "Tron(TRC20)",
        // },
      ],
      typeList: [
        {
          value: 1,
          name: "邮箱",
        },
        {
          value: 2,
          name: "手机号",
        },
        {
          value: 3,
          name: "UID",
        },
      ],
      dialogVisible: false,
      withdrawObj: {},
      withdrawList: [],
      networksList: [],
      beforeRow: null,
      withdrawData: {
        address: "",
        phoneCode: "",
        emailCode: "",
        googleCode: "",
        memo: "",
        amount: "",
        coinType: "",
        emailToken: "",
        password: "",
        phoneToken: "",
        realAmount: 0,
      },
      phoneCodeStatus: {
        hasSend: false,
        times: 60,
      },
      emailCodeStatus: {
        hasSend: false,
        times: 60,
      },

      rules: {
        address: [
          {
            required: true,
            message: this.$t("tipsVal.setChoiceAddress"),
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: this.$t("user_assets.withdraw_amount_placeholder"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("user_assets.trans_password_placeholder"),
            trigger: "blur",
          },
        ],
        phoneCode: [
          {
            required: true,
            message: this.$t("user_assets.phone_code_placeholder"),
            trigger: "blur",
          },
        ],
        emailCode: [
          {
            required: true,
            message: this.$t("user_assets.email_code_placeholder"),
            trigger: "blur",
          },
        ],
        googleCode: [
          {
            required: true,
            message: this.$t("user_assets.google_code_placeholder"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  mounted() {},
  methods: {
    addChoiceAddress() {
      this.$refs.addAssetRef.dialogVisible = true;
    },
    setWithdrawAmount() {
      this.withdrawData.amount = this.withdrawObj.balanceAvailable;
    },
    selectCoinType(coin) {
      this.networksList = [];
      this.networkValue = "";
      this.withdrawObj = {};
      this.withdrawList = [];
      this.withdrawRest();
      this.beforeRow = { assetType: coin };
      this.$axios
        .post("/Coin/getSupportedNetworks", {
          coinType: coin,
          network: "",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.networksList = res.data.networks;
            if (this.networksList && this.networksList.length > 0) {
              this.networkValue = this.networksList[0];
              this.withdrawData.coinType = coin;
              this.queryWithdrawParam();
            } else {
              this.$message({
                type: "error",
                message: "Support network is error!",
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    init(row) {
      this.currRow = row || { assetType: "" };
      this.$axios
        .post("/userAssets/queryAssetList", {})
        .then((res) => {
          if (res.data.code === this.errorCode.ok && res.data.data && res.data.data.userAssetRsps) {
            this.coinTypesList = res.data.data.userAssetRsps.map(item => item.assetType);
            if (this.currRow.assetType && this.coinTypesList.includes(this.currRow.assetType)) {
              this.loadNetworkAndAddress();
            } else if (this.coinTypesList.length > 0) {
              this.currRow.assetType = this.coinTypesList[0];
              this.loadNetworkAndAddress();
            }
          }
        });
      this.dialogVisible = true;
    },
    loadNetworkAndAddress() {
      this.$axios
        .post("/Coin/getSupportedNetworks", {
          coinType: this.currRow.assetType,
          network: "",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.networksList = res.data.networks;
            if (this.networksList && this.networksList.length > 0) {
              this.networkValue = this.networksList[0];
              this.withdrawData.coinType = this.currRow.assetType;
              this.beforeRow = this.currRow;
              this.withdrawRest();
              this.queryWithdrawParam();
            } else {
              this.$message({
                type: "error",
                message: "Support network is error!",
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },

    // 查询提现相关参数
    queryWithdrawParam() {
      this.loading = true;
      this.$axios
        .post("/withdraw/queryByType", {
          coinType: "",
          network: this.networkValue,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.withdrawList = res.data.data;
            this.loading = false;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
            this.loading = false;
          }
        });

      this.$axios
        .post("/userAssets/getWithdrawParam", {
          coinType: this.currRow.assetType,
        })
        .then((res) => {
          this.withdrawObj = res.data.data;
        });
    },

    //初始化提现参数
    withdrawRest() {
      this.withdrawData = {
        coinType: this.withdrawData.coinType,
        phoneCode: "",
        emailCode: "",
        memo: "",
        amount: "",
        emailToken: "",
        password: "",
        phoneToken: "",
        realAmount: 0,
      };
    },
    withdrawAmountChange(withdrawObj) {
      if (this.withdrawData.amount > withdrawObj.balanceAvailable) {
        this.withdrawData.amount = withdrawObj.balanceAvailable;
      } else if (this.withdrawData.amount < withdrawObj.minAmount) {
        this.withdrawData.amount = withdrawObj.minAmount;
      }
      this.withdrawData.amount = this.getFloorNum(
        this.withdrawData.amount,
        withdrawObj.scale,
      );
    },

    hasSendPhoneCode() {
      if (this.user.phoneVerify === -1) {
        this.$confirm(
          this.$t("user_center.need_bind"),
          this.$t("user_center.tip"),
          {
            confirmButtonText: this.$t("user_center.bind_now"),
            cancelButtonText: this.$t("user_center.cancel"),
            type: "warning",
          },
        )
          .then(() => {
            this.$router.push({
              path: "/userCenter/phoneBind",
            });
          })
          .catch(() => {});
        return false;
      }
      this.phoneCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.phoneCodeStatus.times <= 0) {
          this.phoneCodeStatus.hasSend = false;
          this.phoneCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.phoneCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/sendCode/send", {
          verifyType: "phone",
          serviceName: "withdraw",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.withdrawData.phoneToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    hasSendEmailCode() {
      if (this.user.emailVerify === -1) {
        this.$confirm(
          this.$t("user_center.need_bind"),
          this.$t("user_center.tip"),
          {
            confirmButtonText: this.$t("user_center.bind_now"),
            cancelButtonText: this.$t("user_center.cancel"),
            type: "warning",
          },
        )
          .then(() => {
            this.$router.push({
              path: "/userCenter/emailBind",
            });
          })
          .catch(() => {});
        return false;
      }
      this.emailCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.emailCodeStatus.times <= 0) {
          this.emailCodeStatus.hasSend = false;
          this.emailCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.emailCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/sendCode/send", {
          verifyType: "email",
          serviceName: "withdraw",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.withdrawData.emailToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    doWithdraw() {
      this.withdrawData.network = this.networkValue;
      this.$refs.ruleFormAuthentication.validate((valid) => {
        if (valid) {
          if (
            this.withdrawData.amount < this.withdrawObj.minAmount ||
            this.withdrawData.amount > this.withdrawObj.maxAmount
          ) {
            this.$message({
              type: "error",
              message:
                this.$t("user_assets.withdraw_amount_placeholder1") +
                this.withdrawObj.minAmount +
                "，" +
                this.$t("user_assets.withdraw_amount_placeholder2") +
                this.withdrawObj.maxAmount,
            });
            return false;
          }

          this.$axios
            .post("/userAssets/withdraw", this.withdrawData)
            .then((res) => {
              if (res.data.code === this.errorCode.ok) {
                this.$message({
                  type: "success",
                  message: this.$t("user_assets.withdraw_success"),
                });
                this.dialogVisible = false;
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
            });
        }
      });
    },
    typeChange(val) {
      this.networkValue = val;
      this.queryWithdrawParam();
    },
    typeChange1(val) {
      this.typeValue1 = val;
    },
    typeChange2(val) {
      this.typeValue2 = val;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;

  .el-dialog__body {
    padding: 32px 30px;
    position: relative;
  }
}

.close-img {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  position: absolute;
}

.btn {
  width: 100%;
  color: #fff;
  border: none;
  margin-top: 20px;
  background: var(--primary-color);
  border-radius: 9px 9px 9px 9px;
}

.p3 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #f04545;
  // margin-top: -20px;
}

.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 24px;
  color: #333333;
  margin-right: 15px;

  .sel {
    color: var(--primary-color);
  }

  span {
    margin-left: 15px;
    cursor: pointer;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
    color: #333333;
  }
}

.p2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  margin-top: 20px;
}

.tips-box {
  gap: 15px;
  display: flex;
  margin-top: 15px;
  align-items: center;
  padding: 10px 14px;
  background: var(--box-bg-color);
  border-radius: 9px 9px 9px 9px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: var(--primary-color);

  img {
    width: 26px;
    height: 26px;
  }
}

.coin-select {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .type-box {
  gap: 15px;
  display: flex;
  margin-top: 10px;

  p {
    cursor: pointer;
    padding: 12px;
    border-radius: 9px 9px 9px 9px;
    border: 1px solid #d6d8db;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
  }

  .sel {
    color: var(--primary-color);
    border: 1px solid var(--primary-color);
  }
}

.img-box {
  gap: 15px;
  display: flex;
  align-items: center;
  margin-top: 10px;

  img {
    width: 90px;
    height: 90px;
  }

  div {
    flex: 1;
    padding: 12px;
    height: fit-content;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    background: rgba(214, 216, 219, 0.4);
    border-radius: 9px 9px 9px 9px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 18px;
      height: 18px;
    }
  }
}

.input-text {
  cursor: pointer;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: var(--primary-color);
  padding-right: 15px;
}

/deep/.el-input-group--append {
  gap: 16px;
  display: flex;
}

/deep/.el-input-group__append {
  cursor: pointer;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid var(--primary-color);
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: var(--primary-color);
  padding: 0 24px;
  width: auto;
  display: flex;
  align-items: center;
}

.add-choice-address {
  display: flex;
  justify-content: flex-end;

  span {
    cursor: pointer;
    color: var(--primary-color);
  }
}
</style>
